import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import Modal from "../../../ui_components/Modal/Modal";
import {Observer} from "mobx-react-lite";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import useOnEnterPress from '../../../hooks/EnterPress';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import {useUserContext} from "../../../contexts/UserContext";
import Access from "../../Access/AllowAccess/Access";
import CommentInput from '../../Inputs/CommentInput/CommentInput';
import AddArticleStockStore from './AddArticleStockButtonStore';
import AddArticleStockButtonProperties from './AddArticleStockButtonProperties';
import { useStyles } from './AddArticleStockButton.style';
import Tag from '../../../ui_components/Tag/Tag';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import Alert from '../../../ui_components/Alert/Alert';
import AlertType from '../../../ui_components/Alert/AlertType';
import Link from '../../../ui_components/Link/Link';
import ArticlesAmountSelect from '../../Selects/ArticlesAmountSelect/ArticlesAmountSelect';
import { ArticleAmountItem } from '../../Selects/ArticlesAmountSelect/ArticlesAmountSelectProperties';


const AddArticleStockButton: React.FC<AddArticleStockButtonProperties> = ({
                                                                                  onClick = () => {
                                                                                  },
                                                                                  onSave = () => {
                                                                                  },
                                                                                  showIcon = true,
                                                                                  showText = true,
                                                                                  disabled,
                                                                                  className = '',
                                                                                  entityId,
                                                                                  selectedArticle,
                                                                                  isLinkText = false,
                                                                                  rounded = false,
                                                                                  size = ButtonSize.DEFAULT,
                                                                                  type = ButtonType.DEFAULT
                                                                              }) => {
    const classes = useStyles(showText);

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const userStore = useUserContext();
    const store = new AddArticleStockStore(commonContext, entityId, selectedArticle);

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        store.closeModal();
        if (onSave) {
            onSave();
        }
    }

    const onCommentChange = (comment: string) => store.comment = comment;
    const onArticlesChange = (updatedItems: ArticleAmountItem[]) => {
        store.articles = updatedItems;
    };

    const onPersonSave = async () => {
        const saved = await store.save();
        if (saved) {
            store.closeModal();
            onSave && onSave();
        }
    }
    useOnEnterPress(onPersonSave,[store]);

    if (!userStore.hasAccess(Access.CREATE_DELIVERY_PERSON.valueOf())) {
        return <></>;
    }

    const text = 'Adicionar/restar artículos';
    const btnIcon = <FastfoodIcon/>;
    const Btn = () => {
        if (isLinkText) {
            return <Link text={'Adicionar/restar'} onClick={handleOnclick}></Link>
        }
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? btnIcon : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? btnIcon : <></>}
        />
    }
    return <Observer>
        {() => (
            <>
                <Modal fullScreen={false} loading={store.loading} title={text} onClose={onCloseModal} open={store.isModalOpen}>
                    <div className={classes.modal_container}>
                        <div className={classes.hint}>
                            <Tag startIcon={GppMaybeIcon} text={`Para restar artículos, basta colocar un valor negativo en el campo Cantidad.`}/>
                        </div>
                        <CommentInput
                            lines={3}
                            onChange={onCommentChange}
                            fullWidth
                            value={store.comment}
                            className={classes.input}
                        />
                        
                        <ArticlesAmountSelect
                            label={i18n.translate("ARTICLES")}
                            required
                            items={store.articles}
                            onChange={onArticlesChange}
                            disabled={disabled}
                            className={classes.articles_container}
                        />
                        
                         {store.success && (
                            <Alert
                                className={classes.alert}
                                text={`Estoque actualizado con éxito`}
                                type={AlertType.SUCCESS}
                            />
                        )}
                        <div className={classes.btn_container}>
                            <Button
                                disabled={!store.enableButton}
                                loading={store.loading} className={classes.input} onClick={onPersonSave}
                                type={ButtonType.SECONDARY}
                                text={i18n.translate("SAVE")}/>
                        </div>
                    </div>
                </Modal>
                <Btn/>
            </>
        )}
    </Observer>
}

export default AddArticleStockButton;
